<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t("label.createCommune") }}
      </h3>
      <div class="pull-right box-tools">
        <a
          class="btn btn-default btn-sm"
          @click="$router.back()"
        >
          <i class="fa fa-arrow-circle-left" /> {{ $t("button.back") }}
        </a>
      </div>
    </div>
    <div class="box-body">
      <Form />
    </div>
  </div>
</template>

<script>
import Form from './Form'

export default {
  name: 'Create',
  metaInfo () {
    return {
      title: this.$t('string.createNewCommune'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { Form }
}
</script>

<style scoped></style>
